'use client'

import { ReactNode, useEffect, useState } from 'react';

export default function IsAppDetector({ showForAppOnly = false, children }: { showForAppOnly?: boolean, children: ReactNode }) {
    const [isApp, setIsApp] = useState<boolean | null>(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsApp(window.isApp); // Access window only after component mounts
        }
    }, []);

    if (isApp === null) {
        // Return null or loading state while determining whether it's an app or not
        return null;
    }

    return !showForAppOnly ? !isApp && <>{children}</> : isApp && <>{children}</>;
}
